/**
 * Load More button component
 * 
 * @module load-more
 * @version 1.0.0
 * @extends HTMLElement
 */

 customElements.component = 'load-more';

 if(!customElements.get(customElements.component)) {
     
    class loadMore extends HTMLElement {
 
        /**
         * Load More web component.
         * 
         * @constructor
         */
        constructor() {
 
            super();
 
            this.productsContainer = document.querySelector('[data-load-more-grid]');
            this.loadMoreBtn = this.querySelector('[data-load-more-btn]');
            this.urlParams = new URLSearchParams(window.location.search);
 
            if (this.productsContainer && this.loadMoreBtn) {

                const initialPageParam = this.urlParams.get('page');
                this.page = initialPageParam || 1;
                this.count = this.querySelector('[data-count]');

                this.initEvents();

                if(initialPageParam > 1){
                    this.loadPreviously(1, parseInt(this.page));
                }

            }
        }
 
        /**
         * Init component.
         * 
         * @returns {undefined}
         */
        initEvents() {

            this.loadMore = this.loadMore.bind(this);
            this.loadMoreBtn.addEventListener('click', this.loadMore);

            if(this.dataset.infiniteScroll == "true"){
                var observer = new IntersectionObserver( function(entries) {
                    if(entries[0].isIntersecting === true) {
                        // console.log('Element is fully visible in screen');
                        this.loadMore();
                    }
                }.bind(this), { threshold: [1] });
                observer.observe(document.querySelector("[data-loading-infinite-scroll]"));
            }

        }
 
        loadMore() {

            if(this.page >= parseInt(this.dataset.totalPages)){
                return;
            }
 
            this.loadMoreBtn.setAttribute("disabled", "disabled");

            this.page ++;
            
            // const search = window.location.pathname == '/search'
            // ? `?options%5Bprefix%5D=last&page=${this.page}&q=a&type=product` 
            // : `?page=${this.page}`;
            // const url = `${window.location.pathname}${search}`;

            let search = new URLSearchParams(window.location.search);
            search.set("page",this.page);
            const url = `${window.location.pathname}${search != '' ? '?' : ''}${search}`;

            fetch(url).then(response => response.text()).then((responseText) => {

                const html = responseText;

                const html_dom = new DOMParser().parseFromString(html, 'text/html');

                // add new products to the grid
                const newProducts = html_dom.querySelectorAll('[data-load-more-grid] product-card');
                this.productsContainer.append(...newProducts);

                if(this.dataset.gridListView == "true"){
                    const newProductsList = html_dom.querySelectorAll('[data-load-more-grid-list] product-card');
                    document.querySelector('[data-load-more-grid-list]')?.append(...newProductsList);
                }

                // update load more button
                this.count.innerHTML = newProducts.length + parseInt(this.count.innerHTML);

                if (( parseInt(this.count.innerHTML) + parseInt(this.dataset.limit) ) > parseInt(this.dataset.total)) {
                    this.querySelector('[data-limit-count]').innerHTML =  parseInt(this.dataset.total) - parseInt(this.count.innerHTML);
                }

                if(parseInt(this.count.innerHTML) != parseInt(this.dataset.total)) {
                    this.loadMoreBtn.removeAttribute('disabled');
                } else {
                    this.remove();
                }

                let newUrl = new URL(window.location.href);
                newUrl.searchParams.set("page", this.page);
                window.history.pushState({}, '', newUrl.toString());

            });
        }

        loadPreviously(pageInit, pageEnd) {

            let page = pageInit;

            let promiseArray = [];

            while(page <= (pageEnd-1)){
                
                // const search = window.location.pathname == '/search'
                // ? `?options%5Bprefix%5D=last&page=${page}&q=a&type=product` 
                // : `?page=${page}`
                // const url = `${window.location.pathname}${search}`;

                let search = new URLSearchParams(window.location.search);
                search.set("page",page);

                const url = `${window.location.pathname}${search != '' ? '?' : ''}${search}`;
                
                promiseArray.push(  fetch(url).then(response => response.text()) );

                page++;
            }

            Promise.allSettled(promiseArray).then((results) => {

                let productCardData = [];
                let productCardDataList = [];

                results.forEach((result) => {
                    const html = result.value;
                    const html_dom = new DOMParser().parseFromString(html, 'text/html');

                    const newProducts = html_dom.querySelectorAll('[data-load-more-grid] product-card');
                    productCardData = [...productCardData,...newProducts];

                    if(this.dataset.gridListView == "true"){
                        const newProductsList = html_dom.querySelectorAll('[data-load-more-grid-list] product-card');
                        productCardDataList = [...productCardDataList,...newProductsList];
                    }

                });

                return { productCardData: productCardData, productCardDataList: productCardDataList };

            }).then((data) => {

                this.productsContainer.prepend(...data.productCardData);

                if(this.dataset.gridListView == "true"){
                    document.querySelector('[data-load-more-grid-list]')?.prepend(...data.productCardDataList);
                }

                const productCards = this.productsContainer.querySelectorAll('product-card');
                
                this.count.innerHTML = productCards.length;

                if (( parseInt(this.count.innerHTML) + parseInt(this.dataset.limit) ) > parseInt(this.dataset.total)) {
                    this.querySelector('[data-limit-count]').innerHTML =  parseInt(this.dataset.total) - parseInt(this.count.innerHTML);
                }

                if(parseInt(this.count.innerHTML) != parseInt(this.dataset.total)) {
                    this.loadMoreBtn.removeAttribute('disabled');
                } else {
                    this.loadMoreBtn.remove();
                }

            });

        }
 
    }
 
    customElements.define(customElements.component, loadMore);
 }